module.exports = __webpack_public_path__ + "static/media/thumbnail-termelouzem_iroda_kialakitas.d27e4dc0.jpg";